@import '../../assets/styles/components.css';

@layer components {
  :host {
    @apply align-middle inline-block;
    @apply min-w-[1.5rem];
    @apply font-semibold leading-4 text-2xs;
    @apply inline-flex items-center justify-center px-2 py-1;
    @apply rounded-xl;

    .text-wrapper {
      @apply overflow-hidden whitespace-nowrap overflow-ellipsis;
    }

    abds-icon {
      @apply first:mr-1 last:ml-1;
    }

    &([palette='basic']) {
      @apply bg-secondary-50 text-neutral-dark;
    }

    &([palette='dark']) {
      @apply bg-secondary-500 text-neutral-lightest;
    }

    &([palette='error']) {
      @apply bg-danger text-neutral-lightest;
    }

    &([palette='light']) {
      @apply bg-neutral-lightest text-neutral-dark;
      @apply border border-secondary-200 border-solid px-2-border py-1-border;
    }

    &([palette='success']) {
      @apply bg-success text-neutral-dark;
    }

    &([palette='warning']) {
      @apply bg-warning text-neutral-dark;
    }

    &([size='sm']) {
      @apply px-1.5 py-[0.0625rem];
      @apply min-w-[1.125rem];
    }

    &([palette='light'][size='sm']) {
      @apply px-1.5-border py-0;
    }

    &([width='full']) {
      @apply w-full;
    }
  }
}
